<template>
  <div id="CreateClaimContactInfo" class="bg-light pb-5">
    <div class="col">
      <p class="pl-3 py-4">
        Please take a minute to confirm your contact information.
      </p>
      <form class="needs-validation mb-2 no-gutters" novalidate>
        <div class="form-row mx-3 mb-2">
          <div class="pl-0 pr-2 col-lg-4 col-md-6 col-sm-6">
            <label for="customerName"><strong>Name<span class="red-required"><big> *</big></span></strong></label>
            <b-form-input
              id="validateCustomerName"
              v-model="contactInfo.ContactName"
              v-validate="{required: true, min: 2, max: 50}"
              name="FullName"
              type="text"
              size="sm"
              class="form-control"
              :state="ValidateState('FullName')"
            />
            <b-form-invalid-feedback id="claimReasonLiveFeedback">
              Full Name is Required. Name length must be between 2 and 50 characters.
            </b-form-invalid-feedback>
            <b-form-valid-feedback />
          </div>
          <div class="pl-0 pr-2 col-lg-3 col-md-6 col-sm-6">
            <label for="customerPhone"><strong>Phone Number<span
              class="red-required"
            ><big> *</big></span></strong></label>
            <b-form-input
              id="validateCustomerPhone"
              v-model="contactInfo.ContactPhone"
              v-validate="{required: true, max: 50}"
              name="PhoneNumber"
              type="text"
              size="sm"
              class="form-control"
              :state="ValidateState('PhoneNumber')"
            />
            <b-form-invalid-feedback id="claimReasonLiveFeedback">
              Phone Number is Required. Phone Number length must not exceed 50 characters.
            </b-form-invalid-feedback>
            <b-form-valid-feedback />
          </div>
          <div class="pl-0 pr-2 col-lg-1 col-md-3 col-sm-3">
            <label for="customerExtension"><strong>Extension</strong></label>
            <b-form-input
              id="validateCustomerExtension"
              v-model="contactInfo.ContactPhoneExtension"
              v-validate="{max: 50}"
              name="PhoneExtension"
              type="text"
              size="sm"
              class="form-control"
              :state="ValidateState('PhoneExtension')"
            />
            <b-form-invalid-feedback id="claimReasonLiveFeedback">
              Extension must not exceed 50 characters.
            </b-form-invalid-feedback>
          </div>
          <div class="p-0 col-lg-4 col-md-9 col-sm-9">
            <label for="customerEmail"><strong>Email<span class="red-required"><big> *</big></span></strong></label>
            <b-form-input
              id="validateCustomerEmail"
              v-model="contactInfo.ContactEmail"
              v-validate="{required: true, email: true, max: 50}"
              name="Email"
              type="text"
              size="sm"
              class="form-control"
              :state="ValidateState('Email')"
            />
            <b-form-invalid-feedback id="claimReasonLiveFeedback">
              Valid Email is Required. Email length must not exceed 50 characters.
            </b-form-invalid-feedback>
            <b-form-valid-feedback />
          </div>
        </div>
        <div class="form-row mx-3">
          <div class="pl-0 col-lg-4 col-md-6 col-sm-6">
            <label for="customerFax"><strong>Fax Number</strong></label>
            <b-form-input
              id="validateCustomerFax"
              v-model="contactInfo.ContactFax"
              v-validate="{max: 50}"
              name="FaxNumber"
              type="text"
              size="sm"
              class="form-control"
              :state="ValidateState('FaxNumber')"
            />
            <b-form-invalid-feedback id="claimReasonLiveFeedback">
              Fax number must not exceed 50 characters.
            </b-form-invalid-feedback>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { inputValidateState } from "@/components/mixins/inputValidateState"

  export default {
    mixins: [inputValidateState],

    props: {
      contactInfo: {
        type: Object,
        default: () => ({})
      },
      validationState: {
        type: Object,
        default: () => ({}),
        contactInfoTab: { type: Boolean, default: false }
      }
    },
    // All required fields should be set on mounted with user data. This is validating overall state.
    mounted () {
      this.$validator.validateAll().then((result) => {
        this.validationState.contactInfoTab = result
      })
    },
    // Validate overall state again whenever changed are made to any input.
    updated () {
      this.$validator.validateAll().then((result) => {
        this.validationState.contactInfoTab = result
      })
    },
  }
</script>